<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>
      <el-row v-if="info" class="user-row">
        <el-col :span="3" class="table-header">姓名</el-col>
        <el-col :span="3" class="table-header">手机号码</el-col>
        <el-col :span="6" class="table-header">员工编号</el-col>
        <el-col :span="6" class="table-header">所在部门</el-col>
        <el-col :span="6" class="table-header">岗位</el-col>
      </el-row>
      <el-row v-if="info" class="user-row">
        <el-col :span="3" class="line-break">{{info.name}}&nbsp;</el-col>
        <el-col :span="3" class="line-break">{{info.mobile}}&nbsp;</el-col>
        <el-col :span="6" class="line-break">{{info.code}}&nbsp;</el-col>
        <el-col :span="6" class="line-break">{{info.orgName}}&nbsp;</el-col>
        <el-col :span="6" class="line-break">{{info.postName}}&nbsp;</el-col>
      </el-row>
      <br><br>
      <el-row v-if="info" class="user-row">
        <el-col :span="8" class="table-header">创建时间</el-col>
        <el-col :span="8" class="table-header">更新时间</el-col>
        <el-col :span="8" class="table-header">邮箱</el-col>
        <!-- <el-col :span="12" class="table-header">&nbsp;</el-col> -->
      </el-row>
      <el-row v-if="info" class="user-row">
        <el-col :span="8" class="line-break">{{info.createTime}}&nbsp;</el-col>
        <el-col :span="8" class="line-break">{{info.modifyTime}}&nbsp;</el-col>
        <!-- <el-col :span="6">{{info.code}}&nbsp;</el-col> -->
        <el-col :span="8" class="line-break">{{info.email}}&nbsp;</el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  data () {
    return {
      info: null
    }
  },
  computed: {
    eId () {
      return this.$route.query.eId
    }
  },
  watch: {
    eId (val) {
      this.info = null
      if (val) {
        this.getEmployeeInfo()
      }
    }
  },
  mounted () {
    if (this.eId) {
      this.getEmployeeInfo()
    }
  },
  methods: {
    getEmployeeInfo () {
      this.$request.get(`/front/consumer/custorg/sysUserInfo/${this.eId}`)
        .then((res) => {
          this.info = res
        }).catch(() => {})
    }
  }
}
</script>
<style lang='scss' scoped>
.user-row{
  // height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px solid #eee;
  border-top: none;
  .table-header{
    background: #d3dce6;
  }
}

</style>
